import { render, staticRenderFns } from "./demandUserRegionList.vue?vue&type=template&id=5a807338&scoped=true"
import script from "./demandUserRegionList.vue?vue&type=script&lang=js"
export * from "./demandUserRegionList.vue?vue&type=script&lang=js"
import style0 from "./demandUserRegionList.vue?vue&type=style&index=0&id=5a807338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a807338",
  null
  
)

export default component.exports